import { useSheetStore } from '@/shared/stores/sheet-store';

import type { SelectedClient } from './client.types';

// Moving between clients is a new destination, not a deeper level of the trail, so the chart being
// left (and anything stacked over it) is dropped rather than buried under the target's. One
// `setState` so no render ever sees the half-popped stack.
export function openClientChartInPlace(client: SelectedClient) {
    useSheetStore.setState((state) => {
        const leavingChartIndex = state.openSheets.findLastIndex(
            (sheet) => sheet.type === 'clients/details',
        );
        const below =
            leavingChartIndex === -1
                ? state.openSheets
                : state.openSheets.slice(0, leavingChartIndex);
        const target = {
            type: 'clients/details',
            label: client.name,
            data: { id: client.id, name: client.name },
        } as const;

        return { openSheets: [...below, target], currentSheet: target };
    });
}
